// import ScheduleDashboard from "./components/ScheduleDashboard";

const templates = [
    {
        name: "@system/pages/schedule-dashboard",
        // Component: ScheduleDashboard,
        loader: () => import("./components/ScheduleDashboard"),
    },
];

export default templates;